// Format Helpers
// Collection of functions to centralise standard Date, Time, Currency and other formats accross the site

import { PriceOptionViewModel } from "@affinity/Store/StoreTypes";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

// To UK Price (Currency)
export function toUKPrice(value: number | undefined) {
    if (value === undefined) {
        return "";
    }

    return value.toLocaleString("en-GB", { style: "currency", currency: "GBP" });
}

// To UK Unit Price (Currency 4 decimal places)
export function toUKUnitPrice(value: number | undefined) {
    if (value === undefined) {
        return "";
    }

    return value.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 4 });
}

// To Date UK Format
export function toDate(value: string | number | Date | undefined) {
    if (value === undefined) {
        return "";
    }

    const dateOptions: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
    return new Date(value).toLocaleDateString("en-GB", dateOptions);
}

export function getQuantityDescription(quantity: Number | string) {
    // Presume litres for now, can make a site setting or try to read from products
    return `${Number(quantity)?.toLocaleString("en-GB")} litres`;
}

export const formatPriceAndDelivery = ({ deliveryBy, netCost, netUnitPrice }: PriceOptionViewModel) =>
    `Delivery by ${toDate(deliveryBy)} (${toUKPrice(netCost || 0)} @ ${toUKUnitPrice(netUnitPrice)}/l)`;

export function formatAddress(address?: ShipToModel) {
    if (!address) {
        return "";
    }
    const { address1, city, postalCode } = address;
    if (address.companyName) {
        return `${address.companyName} (${[address1, city, postalCode].filter(Boolean).join(", ")})`;
    }
    return [address1, city, postalCode].join(", ");
}
